import { toggleGrid } from "../../Domain/Mesh/Handler/Grid";
import { ihm_viewer__dictionary, locale } from "Application/i18n/i18nViewer";
import { useTools } from "./hooks/useTools";
import { getSkullIcon, getSquare } from "./components/icons/ToolsIcons";
import { DropdownMenu } from "./components/common/DropdownMenu";
import FullscreenComponent from "Ui/Components/Fullscreen";

/**
 * Tools Side Panel
 */
export const Tools = ({ onEditMode, setOnEditMode }) => {
    const {
        AnimationReducer,
        ViewportReducer,
        viewerType,
        mainViewerLayer,
        changeCameraPosition,
        changeActive,
    } = useTools({ onEditMode, setOnEditMode });

    const isSceneLoaded = AnimationReducer.loaded;
    const isAdvancedViewer = viewerType !== "simple";
    const hasPointPlanesJaw = AnimationReducer.metas.pointPlanesJaw;
    const isGridActive = ViewportReducer.gridActive;
    const panelIsHidden = !isSceneLoaded;

    return (
        <nav id="RightPanel" className={panelIsHidden ? "hidden" : ""}>
            <div className="glass-panel">
                <FullscreenComponent />
                {isAdvancedViewer && (
                    <>
                        <button onClick={() => changeActive("all")}>
                            {getSkullIcon("all", mainViewerLayer)}
                        </button>
                        <button onClick={() => changeActive("maxi")}>
                            {getSkullIcon("maxi", mainViewerLayer)}
                        </button>
                        <button onClick={() => changeActive("mandi")}>
                            {getSkullIcon("mandi", mainViewerLayer)}
                        </button>
                    </>
                )}

                <button className="hide-mobile" onClick={() => changeCameraPosition(180, -10, 15)}>
                    {getSquare("RIGHT")}
                </button>
                <button className="hide-mobile" onClick={() => changeCameraPosition(-180, 10, 15)}>
                    {getSquare("LEFT")}
                </button>
                <button
                    className="hide-mobile"
                    onClick={() => {
                        changeActive("maxi");
                        changeCameraPosition(0, -10, -180);
                    }}
                >
                    {getSquare("BOTTOM")}
                </button>
                <button
                    className="hide-mobile"
                    onClick={() => {
                        changeActive("mandi");
                        changeCameraPosition(0, -10, 180);
                    }}
                >
                    {getSquare("TOP")}
                </button>
                <button className="hide-mobile" onClick={() => changeCameraPosition(0, -180, 0)}>
                    {getSquare("FRONT")}
                </button>
                <button className="hide-mobile" onClick={() => changeCameraPosition(0, 180, 10)}>
                    {getSquare("BACK")}
                </button>

                {hasPointPlanesJaw && (
                    <button
                        onClick={toggleGrid}
                        className={`grid-container hide-mobile ${isGridActive ? "grid-active" : ""}`}
                    >
                        {getSquare("GRID")}
                    </button>
                )}

                {isAdvancedViewer && (
                    <span className="hide-mobile">
                    <DropdownMenu
                        trigger={
                            <img
                                src="./helpIcon.png"
                                alt="Help Icon"
                                className="pngIcon help-icon"
                            />
                        }
                    >
                        <a
                            href={ihm_viewer__dictionary.HELP_BTN.PDF_LINK[locale()]}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {ihm_viewer__dictionary.HELP_BTN.PDF_TXT[locale()]}
                        </a>
                        <a
                            href={ihm_viewer__dictionary.HELP_BTN.VIDEO_LINK[locale()]}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {ihm_viewer__dictionary.HELP_BTN.VIDEO_TXT[locale()]}
                        </a>
                    </DropdownMenu>
                    </span>
                )}
            </div>
        </nav>
    );
};

export { getSkullIcon, getSquare } from './components/icons/ToolsIcons';
